const primaryBase = {
  50: '#F9F9FF',
  100: '#EEEFFB',
  200: '#CDCFF5',
  300: '#B5B8EE',
  400: '#9499E6',
  500: '#747ADF',
  600: '#545CD8',
  700: '#4248AF',
  800: '#40458B',
  900: '#2E3058',
}

export const primary = {
  ...primaryBase,
  // https://mui.com/material-ui/customization/palette/
  main: primaryBase[500],
}

export const grey = {
  50: '#F7FAFC',
  100: '#EDF2F7',
  200: '#E2E8F0',
  300: '#CBD5E0',
  400: '#A0AEC0',
  500: '#718096',
  600: '#4A5568',
  700: '#2D3748',
  800: '#1A202C',
  900: '#171923',
}

export const blueGray = {
  100: '#ECEFF1',
  400: '#78909C',
}
